import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

export default function controller() {
    const $ctrl = this;

    $ctrl.mapStatus = mapStatus;
    $ctrl.displayList = displayList;
    $ctrl.hasServiceRequests = hasServiceRequests;
    $ctrl.canShowPrimaryContact = canShowPrimaryContact;
    $ctrl.isInProgress = isInProgress;

    function mapStatus(status) {
        switch (status) {
            case 'workcomplete':
                return 'completed';
            case 'specialistwaiting':
            case 'requested':
            case 'inprogress':
            case 'draft':
                return 'inProgress';
            case 'expired':
            case 'declined':
            case 'canceled':
                return 'offTrack';
            default:
                return 'unknown';
        }
    }

    function displayList(values) {
        return values && values.join ?
            values.join(', ') :
            '';
    }

    function hasServiceRequests() {
        return this.serviceRequests && this.serviceRequests.length > 0;
    }

    function canShowPrimaryContact() {
        return ApplicationFeatures.hasFeature('role.producer') || this.policyType === 'WorkersComp';
    }

    function isInProgress(status) {
        return this.mapStatus(status) === 'inProgress';
    }
}